(() => {
  const initialize = () => {
    document.querySelectorAll('product-info[data-rcc-require-variant]').forEach((productInfo) => {
      if (productInfo.dataset.rccVariantGateReady === 'true') return;
      productInfo.dataset.rccVariantGateReady = 'true';

      const url = new URL(window.location.href);
      if (url.searchParams.has('variant')) return;

      const variantPicker = productInfo.querySelector('variant-selects');
      if (!variantPicker) return;

      productInfo.classList.add('rcc-awaiting-variant');
      variantPicker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        input.checked = false;
        input.removeAttribute('checked');
      });

      variantPicker.querySelectorAll('select').forEach((select) => {
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Choose your frag';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.dataset.rccPlaceholder = 'true';
        select.prepend(placeholder);
      });

      const selectedVariantJson = variantPicker.querySelector('[data-selected-variant]');
      if (selectedVariantJson) selectedVariantJson.textContent = 'null';

      productInfo.querySelectorAll('.product-variant-id').forEach((input) => {
        input.value = '';
        input.disabled = true;
      });

      const submitButton = productInfo.querySelector('[id^="ProductSubmitButton-"]');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        const label = submitButton.querySelector(':scope > span');
        if (label) label.textContent = 'Choose your frag';
      }

      const price = productInfo.querySelector('[id^="price-"]');
      if (price) {
        const prompt = document.createElement('p');
        prompt.className = 'rcc-variant-price-prompt';
        prompt.setAttribute('aria-live', 'polite');
        const minPrice = productInfo.dataset.rccMinPrice;
        const maxPrice = productInfo.dataset.rccMaxPrice;
        prompt.textContent = minPrice === maxPrice ? minPrice : `${minPrice}–${maxPrice}`;
        price.insertAdjacentElement('afterend', prompt);
      }

      const mediaGallery = productInfo.querySelector('media-gallery');
      const sectionId = productInfo.dataset.section;
      const defaultMediaId = productInfo.dataset.rccDefaultMediaId;
      if (mediaGallery && sectionId && defaultMediaId) {
        const activateDefaultMedia = () => {
          requestAnimationFrame(() => {
            mediaGallery.setActiveMedia?.(`${sectionId}-${defaultMediaId}`, true);
          });
        };

        if (customElements.get('media-gallery')) {
          activateDefaultMedia();
        } else {
          customElements.whenDefined('media-gallery').then(activateDefaultMedia);
        }
      }

      const handleVariantSelection = (event) => {
        if (!event.target.closest('variant-selects')) return;

        productInfo.removeEventListener('change', handleVariantSelection, true);
        productInfo.classList.remove('rcc-awaiting-variant');
        productInfo.querySelector('.rcc-variant-price-prompt')?.remove();
        productInfo.querySelectorAll('.product-variant-id').forEach((input) => {
          input.disabled = false;
        });
      };

      productInfo.addEventListener('change', handleVariantSelection, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
